<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <ICICIPayoutTable/>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import ICICIPayoutTable from './ICICIPayoutTable.vue'

  export default {
    name: 'icici-payout-withdraw-detail',
    components: {ICICIPayoutTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/records/ICICIPayout/ICICIPayout.vue